import { IConfig } from '@cian/config/shared';
import { CIAN_PRO_RS_KEY, ECianProGroups } from '../constants/config/cianProExperiment';
import { ELkType, IHeaderV1Schema } from '../repositories/header/entities/response/HeaderV1Schema';
import { IExperiment } from '../types/experiments';
import { checkNewExperiment } from './experiments/checkNewExperiment';

interface ICheckCianProEnabledParams {
  experiments: IExperiment[];
  config: IConfig;
  headerData: IHeaderV1Schema;
}

export function checkCianProEnabled(params: ICheckCianProEnabledParams): boolean {
  const { experiments, config, headerData } = params;
  const { lkType } = headerData;

  const experimentName = config.get<string>(CIAN_PRO_RS_KEY);

  const isInExperiment = !!experimentName && checkNewExperiment(experiments, experimentName, ECianProGroups.enabled);

  return isInExperiment && lkType === ELkType.Specialist;
}
